<template>
    <p>
        Welcome to Guiide. We need to confirm your consent to share the data you enter with <strong>{{ info.companyFullName }}</strong>. This 
        sharing is essential for {{ info.companyAbbrevName }} to provide you with the best possible service.
    </p>

    <p>By proceeding, you agree to the following:</p>

    <ul>
        <li>
            <p><strong>Data Sharing:</strong> The information you provide in our system will be shared with
                {{ info.companyAbbrevName }} for the purpose of managing your account.</p>
        </li>
        <li>
            <p>
                <strong>Privacy and Security:</strong> Your data will be handled in accordance with our <a
                href="https://www.guiide.co.uk/home/privacypolicy" target="_blank">privacy policy</a> and
                {{ info.companyAbbrevName }}'s privacy policy, ensuring it is protected and used responsibly.
            </p>
        </li>
    </ul>

    <p>Do you consent to share your data?</p>

    <dynamic-advice-viewer :message="errorMessage"></dynamic-advice-viewer>

    <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-4">
        <lock-button text="Yes" :async-action="onYesClicked"></lock-button>

        <button
        type="button"
        class="btn btn-secondary text-decoration-none me-md-2"
        aria-label="No"
        v-on:click="onNoClicked"
        >
        No
        </button>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useStore } from 'vuex';
import { app } from '@/guiide/ts/app';
import ConsentInfo from '@/guiide/ts/consent/consentInfo';
import LockButton from '../common/LockButton.vue';
import DynamicAdviceViewer from '../common/DynamicAdviceViewer.vue';

const props = defineProps({
    info: { type: ConsentInfo, required: true }
});

const emit = defineEmits<{(event: 'finished'): void}>();

const store = useStore();
const errorMessage = ref("");

function onNoClicked() {
    const config = store.state.configuration;
    window.location.href = config.anonRedirect;
}

async function onYesClicked() {
    errorMessage.value = "";

    const result = await app.grantConsent(props.info.permittedEntityType, props.info.externalAgency, props.info.consentType, true);

    if (result.successful) {
        emit("finished");
        return;
    } else {
        errorMessage.value = result.message;
    }
}
</script>
